import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { CustomerBillingOtherCustomerModel } from '@fi-app/customer-billing/customer-billing-other-customer/customer-billing-other-customer.model';
import { BillingContactUsingType } from '@fi-app/billing/billing-contact-type';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'fi-customer-billing-reseller-info',
    template: `
        <div class="GroupHeader form-group">
            <span class="Ccm-Label-Wide Bold">{{ sectionText }}</span>
        </div>

        <div class="form-group full-width-material">
            <mat-form-field appearance="outline">
                <mat-label>{{ nameInputLabel }}</mat-label>
                <input matInput [(ngModel)]="ngModel.Name" required />
                <mat-error>{{ 'common_error.mandatory' | fiAppText }}</mat-error>
            </mat-form-field>
        </div>

        <fi-billing-contacts [(ngModel)]="ngModel.Contacts" [usingType]="BillingContactUsingType.Contact">
        </fi-billing-contacts>

        <div class="form-group">
            <fi-address [addOffsetToWideInput]="false" [isMultipleAddresses]="false" [address]="ngModel.Address">
            </fi-address>
        </div>

        <div class="form-group full-width-material">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'common.description' | fiAppText }}</mat-label>
                <textarea matInput fiAutosize="height" [(ngModel)]="ngModel.Description"> </textarea>
            </mat-form-field>
        </div>
    `,
    styleUrls: ['./customer-billing-reseller-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: CustomerBillingResellerInfoComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: CustomerBillingResellerInfoComponent,
        },
    ],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-reseller-info' },
    standalone: false,
})
export class CustomerBillingResellerInfoComponent extends ControlValueAccessorValidatorBase<CustomerBillingOtherCustomerModel> {
    @Input() sectionText: string;
    @Input() nameInputLabel: string;
    BillingContactUsingType = BillingContactUsingType;
}
